import { render } from "./ScheduledSnapshots.vue?vue&type=template&id=290af6e7&scoped=true"
import script from "./ScheduledSnapshots.vue?vue&type=script&lang=js"
export * from "./ScheduledSnapshots.vue?vue&type=script&lang=js"

import "./ScheduledSnapshots.vue?vue&type=style&index=0&id=290af6e7&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290af6e7"]])

export default __exports__